import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { BDC_INVOICE_MAX_COPIES } from "../../../services";

const COPY_OPTIONS = Array.from({ length: BDC_INVOICE_MAX_COPIES + 1 }, (_, n) => n);

/** สำเนา INV ที่พิมพ์ต่อจากต้นฉบับ (0 = ต้นฉบับอย่างเดียว). */
export default function InvoiceCopiesField({
  value,
  onChange,
  disabled = false,
}: Readonly<{ value: number; onChange: (copies: number) => void; disabled?: boolean }>) {
  return (
    <TextField
      select
      size="small"
      label="สำเนา INV"
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      disabled={disabled}
      sx={{ width: 130 }}
      slotProps={{ htmlInput: { "data-testid": "bdc-invoice-copies" } }}
    >
      {COPY_OPTIONS.map((n) => (
        <MenuItem key={n} value={n}>
          {n === 0 ? "ไม่มีสำเนา" : `${n} ฉบับ`}
        </MenuItem>
      ))}
    </TextField>
  );
}
